const config = {
  apiUrl: process.env.REACT_APP_BACKEND_URL || 'https://moonsidehotel.co.uk/API',
};

export default config; 